import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { accessibleSocialPagesSelector } from '../../../../../modules/selectors/socialAccounts'

import useStyles from './styles'

function Avatar({ pageId, size, backgroundColor }) {
  const stylesParams = useMemo(
    () => ({
      size,
      backgroundColor
    }),
    [size, backgroundColor]
  )

  const classes = useStyles(stylesParams)

  const accessibleSocialPages = useSelector(accessibleSocialPagesSelector)

  const page = accessibleSocialPages.find(page => page['external_id'] === pageId)
  const pageThumbnail = page && page.thumbnail

  return <div className={classes.avatar}>{pageThumbnail && <img src={pageThumbnail} alt="" />}</div>
}

Avatar.propTypes = {
  pageId: PropTypes.string,
  size: PropTypes.number,
  backgroundColor: PropTypes.string
}

export default Avatar
